import React from "react";

function useValidate(fn: Function) {
  const [errors, changeErrors] = React.useState<any>({});

  const validate = React.useCallback(() => {
    const valid = fn();
    changeErrors(valid);
    return Object.values(valid).filter((msg) => msg != null).length === 0;
  }, [fn]);

  const clear = React.useCallback(() => {
    changeErrors({});
  }, []);

  return {
    errors,
    validate,
    clear,
  };
}

export default useValidate;
